module.exports = __webpack_public_path__ + "img/logo-text-color.e28b63e7.png";